import { render, staticRenderFns } from "./SyncStatusBadge.vue?vue&type=template&id=516dd361&scoped=true&"
import script from "./SyncStatusBadge.vue?vue&type=script&lang=ts&"
export * from "./SyncStatusBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516dd361",
  null
  
)

export default component.exports